import * as  React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import * as configActions from '../../../../redux/config/actions.config';
import * as  _ from 'lodash';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { popupHeaderIcons } from '../../../../services/mini/popupHeaderIcons';
import ComboBox from '../../../components/ComboBox/ComboBox';
import { validateProjectName } from '../../../../services/validations/validateProjectName';
import ValidationForm from '../../../forms/ValidationForm';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupButtons from '../../../components/Popup/PopupButtons';
import ReactTooltip from 'react-tooltip';
import { cancelButtonClass, okButtonClass } from '../../../../const/popupButtonClasses';

function NewProjectTemplatePopup({
    sluVersions,
    projects,
    getSLUVersionsConfig,
    addNewProject,
    onClose
}) {
    const [predefinedProjects, setPredefinedProjects] = useState(null);
    const [selectedSluKey, setSelectedSluKey] = useState(null);

    useEffect(() => {
        let mounted = true;
        setPredefinedProjects(null);
        getSLUVersionsConfig().then((sluVersions) => {
            setSelectedSluKey(selectedSluKey || sluVersions.filter(v => !v.disabled)[0]?.key || '3');
        });
        return function cleanup() {
            mounted = false;
        };
    }, [getSLUVersionsConfig, selectedSluKey]);

    const validateProjectNameCb = ({ projectName }) => {
        return validateProjectName(projectName, projects);
    }

    const okCb = ({ projectName }) => {
        onClose();
        addNewProject({ projectName: projectName, sluVersion: selectedSluKey });
    }

    return <PopupWrapper className={`new-project-template-popup`}>
        <PopupHeader
            title="Create New Project"
            titleIcon={popupHeaderIcons['add']}
            onCancel={onClose} >
        </PopupHeader>
        <PopupBody>
            {(sluVersions?.length > 0 && selectedSluKey) && <div className="new-project-template-popup__slu-row">
                <span className="new-project-template-popup__slu-label">Runtime Version:</span>
                <ComboBox
                    values={sluVersions}
                    valueKey="key"
                    valueName="value"
                    selectedValueId={selectedSluKey}
                    classes="new-project-template-popup__slu-cbx"
                    renderItem={(sluItem) => {
                        return <div className={`new-project-template-popup__slu-cbx-item  ${sluItem.disabled ? 'disabled-slu-item' : ''}`}>
                            {sluItem.value}
                            {sluItem.disabled !== true ? <></> :
                                <>
                                    <i
                                        className="icon icon-alan-info-sign"
                                        data-for="sluVersionIsNotAvailable"
                                        data-tip="This SLU version is not available on your plan"
                                        data-place="bottom"
                                        data-effect="solid"
                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip custom-logo-is-not-available-tooltip" />
                                    <ReactTooltip id="sluVersionIsNotAvailable" />
                                </>
                            }
                        </div>;
                    }}
                    onValueSelect={(dateRangeItem) => {
                        if (dateRangeItem.disabled !== true) {
                            setSelectedSluKey(dateRangeItem.key);
                        }
                    }}
                />
            </div>}
            <ValidationForm
                buttonsWrapper={PopupButtons}
                enableActionBtnByDefault={true}
                inputs={[{
                    name: 'projectName',
                    label: 'Project name',
                    autoFocus: true,
                    maxLength: 50,
                    maxLengthMsg: `Max project length: 50 characters`,
                    value: '',
                    rules: [validateProjectNameCb],
                    applyOnEnter: true
                }]}
                buttons={[
                    {
                        key: 'cancel',
                        label: 'Cancel',
                        action: onClose,
                        className: cancelButtonClass
                    },
                    {
                        key: 'ok',
                        label: 'Create',
                        action: okCb,
                        className: okButtonClass
                    }
                ]} />
        </PopupBody>
    </PopupWrapper>;
}


function mapStateToProps({ projectsInfo, config }, ownProps) {
    return {
        projects: projectsInfo.projects,
        sluVersions: config.sluVersions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addNewProject: (param) => asyncDispatch(actions.addNewProject, dispatch, param),
        getPredefinedProjects: (param) => asyncDispatch(actions.getPredefinedProjects, dispatch, param),
        getSLUVersionsConfig: () => asyncDispatch(configActions.getSLUVersionsConfig, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(NewProjectTemplatePopup));